var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"player-voice-assistant"},[_c('audio',{ref:"beep",attrs:{"id":"beep","hidden":""}},[_c('source',{attrs:{"src":require("../assets/beep.mp3"),"type":"audio/mpeg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }